import { useCallback, useEffect, useState } from 'react'

import { Input, Modal } from 'antd'
import { useSelector } from 'react-redux'

import FormFooter from '../../../../Components/antd/Forms/FormFooter'
import { ColorsPalette } from '../../../../config/colors'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { NOTE_MAX_LENGTH } from '../../../../utils/api/internshipNote'
import useInternshipNote from '../../../../utils/api/hooks/useInternshipNote'
import { isObject } from '../../../../utils'

const { TextArea } = Input

const MUTED_TEXT_STYLE = { color: ColorsPalette.GREY, fontSize: 'small' }

const InternshipNoteModal = ({ internship, onChange, onClose }) => {
  const t = useSelector(selectTranslate)

  const { note, loading, save, remove } = useInternshipNote(internship, { callback: onChange })

  const [editedNote, setEditedNote] = useState('')

  useEffect(() => setEditedNote(note), [note])

  const handleSubmit = useCallback(() => {
    if (editedNote.trim() === note) {
      onClose()

      return
    }

    save(editedNote).then(saved => saved && onClose())
  }, [editedNote, note, save, onClose])

  const handleDelete = useCallback(() => {
    remove().then(removed => removed && onClose())
  }, [remove, onClose])

  return (
    <Modal
      title={t('internship_note_modal.title')}
      visible={isObject(internship)}
      onCancel={onClose}
      footer={
        <FormFooter
          cancel={{ text: t('modal.cancel_button'), disabled: loading }}
          remove={note !== '' && {
            disabled: loading,
            popover: { content: t('internship_note_modal.popover.delete'), title: t('common.delete') }
          }}
          submit={{ text: t('modal.ok_button.save'), disabled: loading }}
          onCancel={onClose}
          onDelete={handleDelete}
          onSubmit={handleSubmit}
        />
      }
    >
      <div className='mb-8'>{t('internship_note_modal.own_note')}</div>
      <TextArea
        autoFocus
        maxLength={NOTE_MAX_LENGTH}
        placeholder={t('internship_note_modal.placeholder')}
        rows={4}
        value={editedNote}
        onChange={event => setEditedNote(event.target.value)}
      />
      <div style={MUTED_TEXT_STYLE}>{t('internship_note_modal.help')}</div>
    </Modal>
  )
}

export default InternshipNoteModal
